import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ErrorService } from '../../error';
import { catchError } from 'rxjs/operators';
import { CrudType } from '../../service/message/types';
import { AccountModel, AccountType } from '../accounting/types';
import { MessageService } from '../../service/message/message.service';

@Injectable({
  providedIn: 'root',
})
export class AccountApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly errorService: ErrorService,
    private readonly messageService: MessageService,
  ) {}

  getById = (id: number): Observable<AccountModel> => {
    let parameters: string[];
    parameters = [id.toString()];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<AccountModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  add = (accountModel: AccountModel): Observable<AccountModel> => {
    let parameters: string[];
    parameters = [];
    let url = this.formatUrl(parameters);
    return this.httpClient
      .post<AccountModel>(url, accountModel, { observe: 'response' })
      .pipe(
        this.messageService.checkStatusCustomOperator(CrudType.create),
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  update = (accountModel: AccountModel): any => {
    let parameters: string[];
    parameters = [accountModel.id.toString()];
    let url = this.formatUrl(parameters);
    return this.httpClient
      .put<AccountModel>(url, accountModel, { observe: 'response' })
      .pipe(
        this.messageService.checkStatusCustomOperator(CrudType.update),
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  delete = (accountId: number): Observable<boolean> => {
    let parameters: string[];
    parameters = [accountId.toString()];
    let url = this.formatUrl(parameters);

    return this.httpClient.delete<boolean>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  createInstance = (
    accountType: AccountType | undefined,
  ): Observable<AccountModel> => {
    let parameters: string[];
    parameters = ['create'];

    let queryParams = new HttpParams();
    if (accountType) {
      queryParams = queryParams.append('accountType', accountType);
    }
    let url = this.formatUrl(parameters);
    return this.httpClient.get<AccountModel>(url, { params: queryParams }).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  formatUrl = (parameters: string[]): string => {
    var url = environment.comparanooapiurl;
    url += environment.features.account.url;
    parameters.forEach((parameters) => {
      url += '/';
      url += parameters;
    });
    return url;
  };
}
